import {Urls} from "@bounce/shared/consumer/declarations";
import {backofficeUrls} from "./backoffice/backofficeUrls";

export const urls: Urls = {
  ...backofficeUrls,
};
